<div class="flex flex-col h-full">
  <div class="relative flex items-center justify-between mb-4">
    <div class="flex flex-row items-center gap-2" [class.max-w-[80%]]="!!filters">
      <h2 class="m-0 leading-5">{{ title }}</h2>
      <app-icon className="cursor-pointer" *ngIf="tooltip" [matTooltip]="tooltip" iconName="info" size="sm" fill="#1f5792"></app-icon>
    </div>

    <div class="absolute -top-2 right-0">
      <flow-button [matMenuTriggerFor]="menu" theme="secondary" variation="outline" [isCapitalize]="false" *ngIf="!!filters">
        {{ 'global.filter' | translate }}
      </flow-button>
      <mat-menu #menu="matMenu">
        <div class="flex flex-col">
          <ng-content select="[slot=filters]" #filtersSlot></ng-content>
        </div>
      </mat-menu>
    </div>
  </div>

  <div class="flex items-baseline justify-between  border-neutral-200" [ngClass]="hasCompareSlot ? 'py-3 border-y' : 'pt-0 border-b' ">
    <ng-container *ngIf="hasCompareSlot">
      <span class="pr-1" *ngIf="selectedDate">{{ selectedDate }}</span>
      <ng-content select="[slot=compare]" #compareSlot></ng-content>
    </ng-container>
  </div>
  <div class="h-[272px]" *ngIf="!hasData">
    <flow-no-data class="flex justify-center flex-col items-center mt-5" [title]="'global.noData'" [height]="'sm'"></flow-no-data>
  </div>

  <div class="relative h-full mt-5 py-2" *ngIf="hasData">
    <ng-content></ng-content>
  </div>
</div>
